import { Record, Map, List } from "immutable";

import { Location, COUNTRY_ISO_ENUM, ZipSuggestion } from "@typings/locations";
import { LOADING_STATE } from "@typings/reduxThunkActions";

import {
  LocationsReducer,
  LocationsRawResponse,
  SuggestionsRawResponse,
} from "./locations.typings";

const initialLocation = Record<Location>({
  uuid: "",
  zip: "",
  address: "",
  state: "",
  city: "",
  country: "",
  countryIso: COUNTRY_ISO_ENUM.CH,
  firstName: "",
  lastName: "",
  invoicedCompany: "",
  entryCode: "",
  floorAndDoor: "",
  keyPick: "",
  howToGetIn: "",
  hasPets: false,
  previousJobs: 0,
  upcomingJobs: 0,
  ongoingJobs: 0,
  hideCityName: false,
  hasActiveContract: true,
});

export const locationsFactory = (
  input: LocationsRawResponse,
  initialState?: Record<LocationsReducer>,
): Record<LocationsReducer> => {
  const locations = input.locations.reduce(
    (acc: Map<string, Record<Location>>, location: Location) => {
      return acc.set(location.uuid, initialLocation(location));
    },
    Map(),
  );

  return Record<LocationsReducer>({
    defaultLocationId: "",
    invoiceLocationId: "",
    legalLocationId: "",
    locations: Map(),
    b2bLocations: Map(),
    b2bLoadingState: initialState?.get("b2bLoadingState") || LOADING_STATE.IDLE,
    zipSuggestions: List(),
    loadingState: LOADING_STATE.IDLE,
  })({ ...initialState, ...input, locations });
};

export const b2bLocationsFactory = (input: LocationsRawResponse) => {
  const locations = input.locations.reduce(
    (acc: Map<string, Record<Location>>, location: Location) => {
      return acc.set(location.uuid, initialLocation(location));
    },
    Map(),
  );

  return locations;
};

const zipSuggestionFactory = (suggestion: SuggestionsRawResponse) => ({
  value: suggestion.zip,
  label: suggestion.hideCityName
    ? suggestion.zip
    : `${suggestion.zip} - ${suggestion.city}`,
});

export const zipSuggestionsFactory = (
  input: SuggestionsRawResponse[],
): List<ZipSuggestion> => List(input.map(zipSuggestionFactory));
